import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AgreementService } from 'src/app/services/agreement.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiError } from 'src/app/models/api/api-error.model';
import { Component, Inject, inject } from '@angular/core';
import { AppTools } from 'src/app/utils/tools';

@Component({
  selector: 'app-user-agreement-dialog',
  templateUrl: './user-agreement-dialog.component.html',
})
export class UserAgreementDialogComponent {
  private _agreementService: AgreementService = inject(AgreementService);
  private _baseComponentService = inject(BaseComponentService);
  protected _agreementTypes$ = this._agreementService.types$;
  protected error?: ApiError;

  protected userId?: string;
  protected agreementId?: string;
  protected isPosting: boolean = false;
  protected formGroup: FormGroup = new FormGroup({
    user: new FormControl(),
    type: new FormControl(null, Validators.required),
    hours: new FormControl(),
    ral: new FormControl(null, Validators.required),
    monthly_gross: new FormControl(null, Validators.required),
    monthly_net: new FormControl(null, Validators.required),
    code: new FormControl(),
    start: new FormControl(),
    end: new FormControl(),
    description: new FormControl(),
    file: new FormControl(null),
  });

  constructor(
    protected _dialogRef: MatDialogRef<UserAgreementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any
  ) {
    this.userId = this.data.userId;
    if (this.userId) this.formGroup.patchValue({ user: this.userId });
    this.agreementId = this.data.agreementId;
    if (this.agreementId) {
      this.formGroup.get('user')?.disable();
      this._getAgreementDetails();
    }
  }

  private async _getAgreementDetails() {
    this.formGroup.disable();
    this._agreementService
      .getAgreementDetails(this.agreementId)
      .subscribe({
        next: (response) => {
          this.formGroup.patchValue({ ...response.data });
          if (response.data?.start) {
            this.formGroup.patchValue({
              start: response.data.start.toISOString().slice(0, 10),
            });
          }
          if (response.data?.end) {
            this.formGroup.patchValue({
              end: response.data.end.toISOString().slice(0, 10),
            });
          }
        },
        error: (error) => {
          this._baseComponentService.showErrorDialog({ error });
          this._dialogRef.close(false);
        },
      })
      .add(() => this.formGroup.enable());
  }

  protected onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.formGroup?.patchValue({ file: file });
    }
  }

  protected onConfirm() {
    this.isPosting = true;
    this.error = undefined;
    if (this.formGroup.valid === false) {
      this.error = new ApiError({
        message: 'Compila tutti i campi non contrassegnati come opzionali.',
      });
      this.isPosting = false;
      return;
    }
    const formValue = this.formGroup.value;
    const data = AppTools.removeNullAndReplaceWithUndefined({ ...formValue });
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });
    const file: any = this.formGroup.get('file')?.value;
    if (file) {
      if (formData.has('file')) formData.delete('file');
      formData.append(
        'file',
        file,
        file.name || new Date().toISOString().slice(0, 10)
      );
    }
    console.info('FormData:', formData);
    if (this.agreementId) {
      this._agreementService
        .patchAgreement(this.agreementId, formData)
        .subscribe({
          next: () => this._dialogRef.close(true),
          error: (error: ApiError) => {
            this._baseComponentService.showErrorDialog({ error });
          },
        })
        .add(() => (this.isPosting = false));
    } else {
      this._agreementService.postAgreement(formData).subscribe({
        next: (response) => {
          console.info('Post Agreement:', response.data);
          this._dialogRef.close(true);
        },
        error: (error: ApiError) => {
          this._baseComponentService.showErrorDialog({ error });
        },
      });
    }
  }

  protected onDismiss(): void {
    this._dialogRef.close(false);
  }
}
